<script>
import vueMixins from 'viralstyle-ui/src/vueMixins';
import VsTable from 'viralstyle-ui/src/VsTable';

export default {
  components: {
    VsTable,
  },
  mixins: [vueMixins],
  props: {
    deductions: Array,
  },
  data: () => ({
    deductionHeadings: ['Deduction Reason', 'Deduction Amount'],
  }),
};
</script>

<template lang='pug'>
vs-table(v-if='deductions.length', :headings='deductionHeadings')
  .vs-table__row(v-for='(deduction, index) in deductions', :key='index')
    .vs-table__cell.details__half-cell(:data-heading='deductionHeadings[0]')
      h6 {{deduction.memo}}
    .vs-table__cell.details__half-cell(:data-heading='deductionHeadings[1]')
      h6 -{{currency(deduction.amount)}}
</template>

<style>
@import '~import/index';
</style>